<template>
  <div class="mb-8">
  <!--
    Previous inline preview logic (replaced by TopicMediaPreview):
    <div class="mt-4" v-if="selectedTopics.docType == 'pdf'">
      <iframe
        v-if="pdfUrl"
        class="screenht450 w-full -mt-4"
        :src="pdfUrl"
        frameborder="0"
        height="600"
        width="100%"
      ></iframe>
    </div>
    <div v-else-if="selectedTopics.docType == 'video'">
      <video
        width="100%"
        height="100%"
        controls
        controller
        autoplay
        controlsList="nodownload"
        id="video"
        :src="video"
        @pause="getTime()"
      >
        Your browser does not support the video tag.
      </video>
    </div>
  -->
    <div class="mt-4" v-if="hasTopicMedia">
      <TopicMediaPreview
        :doc-path="selectedTopics.docPath"
        :doc-type="selectedTopics.docType"
        video-id="video"
        @pause="getTime"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import TopicMediaPreview from "@/components/TopicMediaPreview.vue";
// Previous imports:
// import { buildMediaUrl, buildPdfPreviewUrl } from "@/utils/mediaUrl";

export default {
  components: {
    TopicMediaPreview,
  },
  props: {
    selectedCourse: {
      type: Object,
    },
  },

  data() {
    return {
      selectedTopicData: {},
      studentId: "",
      // pdfSrc: "", // previous: stored PDF iframe URL from resolvePdfSrc()
    };
  },
  watch: {
    selectedTopics: {
      immediate: true,
      handler(newVal) {
        // Previous PDF URL resolution (replaced by TopicMediaPreview):
        // if (newVal?.docType === "pdf") {
        //   this.resolvePdfSrc(newVal.docPath);
        // } else {
        //   this.pdfSrc = "";
        // }

        if (!newVal?._id) return;

        return new Promise(async (resolve, reject) => {
          try {
            const { data } = await this.$store.dispatch(
              "learningTracker/getSingle",
              {
                course: this.selectedCourse._id,
                student: this.studentId,
                chapter: this.selectedTopics.chapter.toString(),
                topic: this.selectedTopics._id,
              }
            );
            this.selectedTopicData = data;
            if (this.selectedTopics.docType === "video") {
              this.$nextTick(() => this.resumeVideo());
            }
            resolve(data);
          } catch (err) {
            reject(err);
          }
        });
      },
    },
  },
  methods: {
    async getStudent() {
      this.chapter = this.selectedCourse.chapter;
      const { data } = await this.$store.dispatch(
        "student/getStudentByUserId",
        {
          userId: this.userData._id,
        }
      );
      this.studentId = data[0]._id;
      if (Object.keys(this.selectedTopics).length !== 0) {
        return new Promise(async (resolve, reject) => {
          try {
            const { data } = await this.$store.dispatch(
              "learningTracker/getSingle",
              {
                course: this.selectedCourse._id,
                student: this.studentId,
                chapter: this.selectedTopics.chapter.toString(),
                topic: this.selectedTopics._id,
              }
            );
            this.selectedTopicData = data;
            if (this.selectedTopics.docType === "video") {
              this.$nextTick(() => this.resumeVideo());
            }
            resolve(data);
          } catch (err) {
            reject(err);
          }
        });
      }
    },
    async getTime() {
      let video = document.getElementById("video");
      if (!video) return;

      let totalTime = 0;
      let status = "";
      this.selectedTopicData.map(
        (data) => ((totalTime = data.totalTime), (status = data.status))
      );

      if (totalTime > Math.floor(video.currentTime) && status != "completed") {
        await this.$store.dispatch("learningTracker/updateLearning", {
          course: this.selectedCourse._id,
          student: this.studentId,
          chapter: this.selectedTopics.chapter.toString(),
          topic: this.selectedTopics._id,
          watchTime: Math.floor(video.currentTime),
        });
      } else if (totalTime - 5 <= Math.floor(video.currentTime)) {
        await this.$store.dispatch("learningTracker/updateLearning", {
          course: this.selectedCourse._id,
          student: this.studentId,
          chapter: this.selectedTopics.chapter.toString(),
          topic: this.selectedTopics._id,
          watchTime: Math.floor(video.currentTime),
          status: "completed",
        });
      }
    },
    // Previous PDF preview helpers (replaced by TopicMediaPreview + mediaUrl.js):
    // resolvePdfSrc(docPath) {
    //   this.pdfSrc = buildPdfPreviewUrl(docPath, this.$imageURL);
    // },
    // normalizePdfPath(docPath) { ... }
    // buildMediaUrl(docPath, base) { ... }
    resumeVideo() {
      const videoEl = document.getElementById("video");
      if (!videoEl) return;

      let time = 0;
      this.selectedTopicData.map((data) => (time = data.watchTime));
      videoEl.addEventListener(
        "loadedmetadata",
        function () {
          this.currentTime = time;
        },
        false
      );
    },
  },
  mounted() {
    this.getStudent();
  },
  computed: {
    ...mapState("auth", ["userData"]),
    ...mapState("eLearning", ["selectedTopics"]),
    hasTopicMedia() {
      return (
        this.selectedTopics?.docPath &&
        (this.selectedTopics.docType === "pdf" ||
          this.selectedTopics.docType === "video")
      );
    },
    // Previous computed preview URLs (replaced by TopicMediaPreview):
    // video() {
    //   return buildMediaUrl(this.selectedTopics.docPath, this.$imageURL);
    // },
    // pdfUrl() {
    //   return this.pdfSrc;
    // },
  },
};
</script>
